/**
 * @file: orderTags.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { uniq } from 'ramda';
import { comparer } from './comparer';

export const parseTagsFromString = (s: string) => {
  return uniq(s.split(/\s*[,，;；]\s*/g).filter(x => x));
};

// normalized tag list in form of 'a,b,c,'
export const normalizedOrderTags = (s: string) => {
  const tags = parseTagsFromString(s);
  return tags.join(',') + (tags.length ? ',' : '');
};

export const orderTagsEqual = (
  tags1: string[] | undefined,
  tags2: string[] | undefined,
) => {
  const [a, b] = [uniq(tags1 ?? []), uniq(tags2 ?? [])];
  return a.sort(comparer).join(',') === b.sort(comparer).join(',');
};
